<div class="table__container">
  <ng-container *ngIf="(elements.length > 0); else blankSlateAuthorizeTable">
    <table class="table table-border round-corner">
      <thead>
        <tr>
          <th scope="col" class="text-center" width="45" [ngSwitch]="headerCheckboxState"
            (click)="onHeaderCheckboxChange()">
            <fa-icon class="fa-lg mr-1" [icon]="['fal','square']" *ngSwitchCase="checkboxState.Unchecked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','check-square']" *ngSwitchCase="checkboxState.Checked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','minus-square']"
              *ngSwitchCase="checkboxState.Indeterminate"></fa-icon>
          </th>
          <th scope="col" class="text-left">{{ 'name' | translate | titlecase }}</th>
          <th scope="col" class="text-left">{{ 'mail' | translate | titlecase }}</th>
          <th *ngIf="isShowSSN()" scope="col" class="text-left">{{ 'ssn' | translate | uppercase }} </th>
          <th *ngIf="!hiddenPhoneColumn" scope="col" class="text-left">{{ 'phone' | translate }} </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let element of elements; let i = index" class="cursor" (click)="onCheckboxClick(element)">
          <td width="10%" class="text-center text-overflow-none">
            <fa-icon class="fa-lg mr-1" [icon]="['fal','square']" *ngIf="!element.checked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','check-square']" *ngIf="element.checked"></fa-icon>
          </td>
          <td width="30%" class="text-truncate text-left">{{element.name}}</td>
          <td width="20%" class="text-truncate text-left">{{element.mail}}</td>
          <td width="15%" *ngIf="isShowSSN()" class="text-truncate text-left">{{ setMaskValue(element.ssn) }}</td>
          <td width="15%" *ngIf="!hiddenPhoneColumn" class="text-truncate text-left">{{element.phoneNumber | phoneObfuscate}}</td>
        </tr>
      </tbody>
    </table>

  </ng-container>
</div>

<ng-template #blankSlateAuthorizeTable>
  <cdx-blankslate [options]="blankslateOptions" (buttonClick)="onBlankSlateButtonClick($event)">
    {{ 'envelope.authorizer.modalAdd.noAuthorizersFounded' | translate }} </cdx-blankslate>
</ng-template>
